import {createSlice, isAnyOf} from '@reduxjs/toolkit'
import { ORDER_ITEM } from 'src/app/_interfaces/order.interface'
import {
  getOrdersListAsync,
  orderResyncAsync,
  shippingResyncAsync,
  downloadShippingLabelsAsync,
  downloadOrderPackingSlipAsync,
} from '../actions/orderActions'

type InitialState = {
    orderListLoading:boolean
    orderList:ORDER_ITEM[]|[]
    orderPaginationData:{
        // next:string|null
        // previous:string|null
        pageNumber:number
        count:number
    }
    orderResyncLoading:boolean
    orderResyncData:any
    invoice_status_available:boolean
    cancel_status_available:boolean
    shipping_label_status_available:boolean
    shippingLabelsLoading:boolean
    shippingLabelsData:string[] | null
    orderDocumentsDownloadLoading:boolean
    currentOrdersRequestId:string | null
}
const initialState:InitialState  = {
  orderListLoading:false,
  orderList:[],
  orderPaginationData:{
    count:0,
    pageNumber:0
  },
  orderResyncLoading:false,
  orderResyncData:null,
  invoice_status_available:false,
  cancel_status_available:false,
  shipping_label_status_available:false,
  shippingLabelsLoading:false,
  shippingLabelsData:null,
  orderDocumentsDownloadLoading:false,
  currentOrdersRequestId:null

  
}

const orderSlice = createSlice({
  name: 'orderSlice',
  initialState,
  extraReducers: (builder) => {
    // login start
    builder.addMatcher(isAnyOf(getOrdersListAsync.pending), (state, action: any) => {
      console.log('getOrdersListAsync is in pending state ')
      state.orderListLoading = true
      state.currentOrdersRequestId = action?.meta?.requestId ?? null
    })
    builder.addMatcher(isAnyOf(getOrdersListAsync.rejected), (state, action: any) => {
      // Ignore stale responses that don't belong to the latest list request.
      if (
        state.currentOrdersRequestId &&
        action?.meta?.requestId &&
        action.meta.requestId !== state.currentOrdersRequestId
      ) {
        return
      }
      console.log('getOrdersListAsync is in rejected state ')
      state.orderListLoading = false
      state.currentOrdersRequestId = null
    })
    builder.addMatcher(isAnyOf(getOrdersListAsync.fulfilled), (state, action: any) => {
        // Ignore stale responses that don't belong to the latest list request.
        if (
          state.currentOrdersRequestId &&
          action?.meta?.requestId &&
          action.meta.requestId !== state.currentOrdersRequestId
        ) {
          return
        }
        console.log('getOrdersListAsync is in fulfilled state ', action.payload )
        state.orderListLoading = false
        state.orderList = action.payload?.results
        state.orderPaginationData.count = action.payload?.count
        state.invoice_status_available = action.payload?.invoice_status_available
        state.cancel_status_available = action.payload?.cancel_status_available
        state.shipping_label_status_available = action.payload?.shipping_label_status_available
        state.currentOrdersRequestId = null

          // Update the current page number in the state
        // state.orderPaginationData.pageNumber = action.payload.currentPageNumber+1; // Adjust this line based on your actual response data structure
   

    })
      //order resync slice start

    builder.addMatcher(isAnyOf(orderResyncAsync.pending), (state) => {
      console.log('orderResyncAsync is in pending state ')
      state.orderResyncLoading = true
    })
    builder.addMatcher(isAnyOf(orderResyncAsync.rejected), (state) => {
      console.log('orderResyncAsync is in rejected state ')
      state.orderResyncLoading = false
    })
    builder.addMatcher(isAnyOf(orderResyncAsync.fulfilled), (state, action) => {
        console.log('orderResyncAsync is in fulfilled state ', action.payload )
        state.orderResyncLoading=false
        state.orderResyncData=action?.payload?.message

    })
            //order resync slice ends

    //shipping resync slice start

    builder.addMatcher(isAnyOf(shippingResyncAsync.pending), (state) => {
      console.log('shippingResyncAsync is in pending state ')
      state.orderResyncLoading = true
    })
    builder.addMatcher(isAnyOf(shippingResyncAsync.rejected), (state) => {
      console.log('shippingResyncAsync is in rejected state ')
      state.orderResyncLoading = false
    })
    builder.addMatcher(isAnyOf(shippingResyncAsync.fulfilled), (state, action) => {
        console.log('shippingResyncAsync is in fulfilled state ', action.payload )
        state.orderResyncLoading=false
        state.orderResyncData=action?.payload?.message

    })
            //shipping resync slice ends

    //download shipping labels slice start

    builder.addMatcher(isAnyOf(downloadShippingLabelsAsync.pending), (state) => {
      console.log('downloadShippingLabelsAsync is in pending state ')
      state.shippingLabelsLoading = true
    })
    builder.addMatcher(isAnyOf(downloadShippingLabelsAsync.rejected), (state) => {
      console.log('downloadShippingLabelsAsync is in rejected state ')
      state.shippingLabelsLoading = false
    })
    builder.addMatcher(isAnyOf(downloadShippingLabelsAsync.fulfilled), (state, action) => {
        console.log('downloadShippingLabelsAsync is in fulfilled state ', action.payload )
        state.shippingLabelsLoading=false
        state.shippingLabelsData=action?.payload

    })
            //download shipping labels slice ends

    builder.addMatcher(isAnyOf(downloadOrderPackingSlipAsync.pending), (state) => {
      state.orderDocumentsDownloadLoading = true
    })
    builder.addMatcher(isAnyOf(downloadOrderPackingSlipAsync.rejected), (state) => {
      state.orderDocumentsDownloadLoading = false
    })
    builder.addMatcher(isAnyOf(downloadOrderPackingSlipAsync.fulfilled), (state) => {
      state.orderDocumentsDownloadLoading = false
    })

  },
  reducers: { 
    
  },
})

export const {} = orderSlice.actions

export default orderSlice.reducer
